module.exports = __webpack_public_path__ + "static/media/bacon-egger-desktop-250_fr.3c1b5a64.jpg";